import React from 'react';
import { Numbers, Radio } from '@weezevent/nacre';
import css from '../modal-popup.module.css';
import i18n from 'i18next';

export default function RateItem({ rate, onChange, checked, currency }) {
    const { language: locale } = i18n;

    const handleCheck = React.useCallback(() => {
        onChange(rate);
    }, [rate, onChange]);

    return (
        <div className={css['rate-item-seats']}>
            <div className={`${css['modal-popup-item']} ${css['rate-item-seats']}`}>
                <span className={`${css['popup-item-label']} ${css['rate-item-seats']}`}>{rate.resolved_name}</span>
                <span className={`${css['popup-item-selector']} ${css['rate-item-seats']}`}>
                    <Numbers className={`${css['price-tag']} ${css['rate-item-seats']}`} value={rate.resolved_price} locale={locale} currency={currency} showNullDecimal={false} />
                    <Radio onClick={handleCheck} checked={checked} style={{ width: 'auto' }} />
                </span>
            </div>
        </div>
    );
}
